import { isNumeric } from "../../../utilities/strings";
import { UNITS } from '../../../resources/constants';
import { sumArray } from '../../../utilities/arrays';
/**
 * validate
 * @param {*} setErrors
 * @param {*} state
 * @returns
 */
const validate = (setErrors, state) => {
  const { totalQuantity, solvent, solventPercent, unit, apiList } = state;

  let newErrors = {};
  let validated = true;

  //handle totalQuantity
  if (!isNumeric(totalQuantity) || totalQuantity <= 0) {
    newErrors.totalQuantity = "Please supply a valid Total Quantity Desired";
    validated = false;
  }

  //handle solvent
  if (solvent === null) {
    newErrors.solvent = "Please select a solvent";
    validated = false;
  }

  //handle solventPercent
  if (!isNumeric(solventPercent) || solventPercent < 0 || solventPercent >= 100) {
    newErrors.solventPercent = "Please select a valid percentage";
    validated = false;
  }

  //handle apiList errors
  let apiErrors = [];
  apiList.forEach((item, i) => {
    const { quantity } = item;
    let apiError = {};
    if (!isNumeric(quantity)) {
      apiError.quantity = "Please supply a valid quantity";
      validated = false;
    }
    apiErrors.push(apiError);
  });
  newErrors.apiList = apiErrors;

  //handle unit: percents
  if (unit === UNITS.percent) {
    let percentSum = sumArray(apiList.map(x => parseFloat(x.quantity || 0)));
    percentSum += parseFloat(solventPercent || 0);
    if (percentSum > 100) {
      newErrors.unit = `Ensure all percentages sum correctly.`;
      validated = false;
    }
  }
  //handle unit: mg/g
  if (unit === UNITS.mgPerGram && apiList.some(x => (parseFloat(x.quantity || 0) >= 1000))) {
    newErrors.unit = "Ensure all quantities are below 1000 mg/g";
    validated = false;
  }

  
  //set and return
  setErrors(newErrors);
  return validated;
};

export default validate;
